<template>
  <div class="bl-register-wrap">
    <div class="bl-bg-head"></div>
    <div class="bl-register-box" v-loading="loading">
      <v-register-step :stepType='registerId'></v-register-step>
      <div class="registerSuccess">
          <div>
          <p class="font-size-20 p-t-24">{{$t('Completed Registration')}}</p>
          <div class="registerSuccess_img">
              <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/registerSuccess.png"/>
          </div>
          <!-- 审核通过 注册成功 -->
          <template v-if="info.visitor.auditState == 'APPROVE'">
            <!-- <h4 class="font-size-16 p-b-24">{{$t('registerCompletedTips')}}</h4> -->
            <p class="font-size-12 text-left p-b-24">{{$t('registerSuccessContent')}}</p>
          </template>
          <!-- 审核中 -->
          <template v-if="info.visitor.auditState == 'PENDING'">
            <!-- <h4 class="font-size-16 p-b-24">{{$t('registerCompletedTips1')}}</h4> -->
            <p class="font-size-12 text-left p-b-24">{{$t('registerSuccessContent1')}}</p>
          </template>
          <!-- 审核不通过 -->
          <template v-if="info.visitor.auditState == 'DISAPPROVE'">
            <!-- <h4 class="font-size-16 p-b-24">{{$t('registerCompletedTips2')}}</h4> -->
            <p class="font-size-12 text-left p-b-24">{{$t('registerSuccessContent2')}}</p>
          </template>
          <div class="font-size-12 p-b-24 p-t-24">
              <el-button type="primary" class="gohome" @click="registrationBackHome(false)">{{ $t('goHome') }}</el-button>
          </div>
          </div>
          
      </div>
      <loginBottom></loginBottom>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import vRegisterStep from '@/components/login/register_step.vue'
import registerSuccess from '@/assets/images/registerSuccess.png'
import loginBottom from '@/components/login/loginBottom.vue'
// 拿取是否只能注册配置
// import statuConfig from "@/config/settings"

export default {
  name: 'vRegisterSuccess',
  components: {
    vRegisterStep,
    loginBottom
  },
  data() {
    return {
      registerId:6,
      registerSuccess: registerSuccess,
      loading: false,
      disabled: false
    }
  },
  computed: {
    ...mapGetters(['language', 'loginAccount', 'subjectType', 'info'])
  },
  mounted() {
    window.PC.$RangersEventLoginAndRegister('Registrationcompletedpage_view')
    this.$tracking('010701')
  },
  methods: {

  }
}
</script>
<style lang="stylus">
.registerSuccess{
  width 340px;
  margin 0 auto;
  text-align center;
  height 600px
  .registerSuccess_img{
    width 261px
    height 183px
    margin 40px auto
    img{
      width 100%
      height 100%
    }
  }
  .gohome{
    width 100%
  }
}
</style>
